var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfilePlum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 75,
    fill: "#E3F6B1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1474_2856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106 54H41V116H106V54Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 42H44V53H62V42Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 52H55V59H91V52Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 41H47V50H102V41Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.44 63.9099H96.2V69.5599H103.44V63.9099Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 48H102V113H108V48Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 31H52V49H95V31Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3802 35.8198H84.6802V41.3298H95.3802V35.8198Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 98H96V114H112V98Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 103H90V114H110V103Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 109H85V115H112V109Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6101 35.8201H52.1001V41.3301H62.6101V35.8201Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9701 69.5901H40.3201V75.2401H45.9701V69.5901Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104 47H90V64H104V47Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5501 63.9099H40.3201V69.5999H51.5501V63.9099Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2001 52.6201H68.3101V58.3201H74.2001V52.6201Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 47H40V83H56V47Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2001 63.9099H51.55V71.6699H96.2001V63.9099Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.69 69.5901H45.9399V97.5301H101.69V69.5901Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3801 75.24H40.3201V98.02H46.3801V75.24Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2 96.6899H45.71V103.75H96.2V96.6899Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.39 103.08H51.55V109.22H90.39V103.08Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.16 108.98H57V114.73H85.16V108.98Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 98H36V115H46V98Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 104H41V115H52V104Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 109H42V115H57V109Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 30H52V36H96V30Z",
    fill: "#006737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113 52H107V115H113V52Z",
    fill: "#006737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 114H40V120H108V114Z",
    fill: "#006737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 53H35V115H41V53Z",
    fill: "#006737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 46H39V53H46V46Z",
    fill: "#006737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 41H42V48H49V41Z",
    fill: "#006737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.11 35.8201H46.55V41.3301H52.11V35.8201Z",
    fill: "#006737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.89 35.8201H95.3799V41.3301H100.89V35.8201Z",
    fill: "#006737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 40H99V47H105V40Z",
    fill: "#006737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.15 46.9099H103.45V52.6099H109.15V46.9099Z",
    fill: "#006737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 52H74V59H80V52Z",
    fill: "#FAF0D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 50H56V59H68V50Z",
    fill: "#FAF0D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 47H56V53H91V47Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4399 74.77H53.8899V76.94H58.4399V74.77Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4399 74.53H53.8899V74.78H58.4399V74.53Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8799 74.53H53.6399V76.94H53.8799V74.53Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6799 74.77H58.4399V76.94H58.6799V74.77Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6799 74.53H58.4399V74.77H58.6799V74.53Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8799 74.53H53.6299V74.78H53.8799V74.53Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6301 74.78H61.0801V76.95H65.6301V74.78Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6301 74.53H61.0801V74.78H65.6301V74.53Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0601 74.54H60.8201V76.95H61.0601V74.54Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8599 74.78H65.6199V76.92H65.8599V74.78Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8799 74.53H65.6199V74.78H65.8799V74.53Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8299 76.95H58.6799V79.31H60.8299V76.95Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0299 76.95H65.8799V84.11H68.0299V76.95Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.63 76.95H51.48V84.11H53.63V76.95Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.64 84.1101H63.47V86.3101H65.64V84.1101Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.24 86.53H61.04V88.73H63.24V86.53Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8399 88.9099H58.6699V91.1499H60.8399V88.9099Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.46 86.53H56.29V88.73H58.46V86.53Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0399 84.1101H53.8699V86.3101H56.0399V84.1101Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8799 76.95H53.6399V86.5299H53.8799V76.95Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8799 76.95H65.6199V86.5299H65.8799V76.95Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2899 86.3101H53.8699V86.5301H56.2899V86.3101Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.46 88.73H56.04V88.95H58.46V88.73Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.06 91.1501H58.46V91.3701H61.06V91.1501Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2399 88.73H60.9399V88.95H63.2399V88.73Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.67 88.9099H58.46V91.1499H58.67V88.9099Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0401 88.8401H60.8301V91.1501H61.0401V88.8401Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.47 84.1101H63.24V88.9501H63.47V84.1101Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6699 76.95H53.8799V84.11H58.6699V76.95Z",
    fill: "#D91862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8299 79.3201H58.6699V88.7101H60.8299V79.3201Z",
    fill: "#D91862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2401 81.74H60.8201V86.53H63.2401V81.74Z",
    fill: "#D91862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.62 81.74H63.24V84.11H65.62V81.74Z",
    fill: "#D91862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.76 84.1101H56.29V86.3101H58.76V84.1101Z",
    fill: "#D91862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2401 79.3201H61.0801V81.7401H63.2401V79.3201Z",
    fill: "#C91C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.67 86.3101H56.29V86.5301H58.67V86.3101Z",
    fill: "#B14E65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0501 86.53H60.8201V88.91H61.0501V86.53Z",
    fill: "#B14E65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8399 88.71H58.6699V88.93H60.8399V88.71Z",
    fill: "#B14E65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.68 86.53H58.46V88.93H58.68V86.53Z",
    fill: "#89565F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0701 79.3201H60.8201V81.8501H61.0701V79.3201Z",
    fill: "#D91862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0701 76.95H60.8201V79.32H61.0701V76.95Z",
    fill: "#917886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2401 76.95H61.0701V79.32H63.2401V76.95Z",
    fill: "#F49EC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6 79.5701H63.47V81.5001H65.6V79.5701Z",
    fill: "#F49EC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.62 76.95H63.47V79.32H65.62V76.95Z",
    fill: "#FCEFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.47 76.95H63.24V79.31H63.47V76.95Z",
    fill: "#F9DBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.47 79.3201H63.24V81.7401H63.47V79.3201Z",
    fill: "#DC6F8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.62 79.3201H63.47V79.5701H65.62V79.3201Z",
    fill: "#F6B2D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.62 81.5H63.47V81.74H65.62V81.5Z",
    fill: "#EC83A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.29 84.1101H56.04V86.3101H56.29V84.1101Z",
    fill: "#89565F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.29 86.53H56.04V88.73H56.29V86.53Z",
    fill: "#89565F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.64 86.3101H63.47V86.5301H65.64V86.3101Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6799 74.8H80.1299V76.9701H84.6799V74.8Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6799 74.55H80.1299V74.8H84.6799V74.55Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1199 74.5601H79.8799V76.9701H80.1199V74.5601Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9199 74.8H84.6799V76.9701H84.9199V74.8Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9199 74.5601H84.6799V74.8001H84.9199V74.5601Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1299 74.55H79.8799V74.8H80.1299V74.55Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8701 74.8H87.3201V76.9701H91.8701V74.8Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8701 74.55H87.3201V74.8H91.8701V74.55Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3101 74.5601H87.0701V76.9701H87.3101V74.5601Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1099 74.8H91.8699V76.94H92.1099V74.8Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1299 74.55H91.8699V74.8H92.1299V74.55Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0699 76.97H84.9199V79.33H87.0699V76.97Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2799 76.97H92.1299V84.13H94.2799V76.97Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.88 76.97H77.73V84.13H79.88V76.97Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.89 84.1301H89.72V86.3301H91.89V84.1301Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.49 86.55H87.29V88.75H89.49V86.55Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0799 88.9399H84.9099V91.1799H87.0799V88.9399Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.71 86.55H82.54V88.75H84.71V86.55Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2899 84.1301H80.1199V86.3301H82.2899V84.1301Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1199 76.97H79.8799V86.55H80.1199V76.97Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1299 76.97H91.8699V86.55H92.1299V76.97Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5399 86.3401H80.1199V86.5601H82.5399V86.3401Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.71 88.75H82.29V88.97H84.71V88.75Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.31 91.1702H84.71V91.3902H87.31V91.1702Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4899 88.75H87.1899V88.97H89.4899V88.75Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.92 88.9399H84.71V91.1799H84.92V88.9399Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2901 88.8601H87.0801V91.1701H87.2901V88.8601Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.72 84.1301H89.49V88.9701H89.72V84.1301Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9199 76.97H80.1299V84.13H84.9199V76.97Z",
    fill: "#D91862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0699 79.3401H84.9099V88.7301H87.0699V79.3401Z",
    fill: "#D91862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4901 81.76H87.0701V86.55H89.4901V81.76Z",
    fill: "#D91862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.87 81.76H89.49V84.13H91.87V81.76Z",
    fill: "#D91862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.01 84.1301H82.54V86.3301H85.01V84.1301Z",
    fill: "#D91862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4801 79.3401H87.3201V81.7601H89.4801V79.3401Z",
    fill: "#C91C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.92 86.3401H82.54V86.5601H84.92V86.3401Z",
    fill: "#B14E65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3001 86.55H87.0701V88.93H87.3001V86.55Z",
    fill: "#B14E65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0799 88.73H84.9099V88.95H87.0799V88.73Z",
    fill: "#B14E65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.93 86.55H84.71V88.9501H84.93V86.55Z",
    fill: "#89565F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3201 79.3401H87.0701V81.8701H87.3201V79.3401Z",
    fill: "#D91862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3201 76.97H87.0701V79.34H87.3201V76.97Z",
    fill: "#917886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4901 76.97H87.3201V79.34H89.4901V76.97Z",
    fill: "#F49EC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.85 79.5901H89.72V81.5201H91.85V79.5901Z",
    fill: "#F49EC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.87 76.97H89.72V79.34H91.87V76.97Z",
    fill: "#FCEFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.72 76.97H89.49V79.33H89.72V76.97Z",
    fill: "#F9DBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.72 79.3401H89.49V81.7601H89.72V79.3401Z",
    fill: "#DC6F8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.87 79.3401H89.72V79.5901H91.87V79.3401Z",
    fill: "#F6B2D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.87 81.52H89.72V81.76H91.87V81.52Z",
    fill: "#EC83A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.54 84.1301H82.29V86.3301H82.54V84.1301Z",
    fill: "#89565F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.54 86.55H82.29V88.75H82.54V86.55Z",
    fill: "#89565F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.89 86.3401H89.72V86.5601H91.89V86.3401Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8799 90.04H64.4299V94.83H66.8799V90.04Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0599 92.4399H71.6699V94.8299H74.0599V92.4399Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0098 90.04H78.5598V94.83H81.0098V90.04Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6699 94.8301H66.8799V97.1301H71.6699V94.8301Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5498 94.8301H74.0598V97.1301H78.5498V94.8301Z",
    fill: "#221E1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1474_2856"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77.76,
    height: 90.48,
    fill: "white",
    transform: "translate(35 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePlum);
export default __webpack_public_path__ + "static/media/ProfilePlum.5901223466a7fb5a5255d98f9a8926f4.svg";
export { ForwardRef as ReactComponent };